import { render } from "./ProductCategoryBestSellerSkeleton.vue?vue&type=template&id=45f4b51e&scoped=true"
import script from "./ProductCategoryBestSellerSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCategoryBestSellerSkeleton.vue?vue&type=script&lang=js"

import "./ProductCategoryBestSellerSkeleton.vue?vue&type=style&index=0&id=45f4b51e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f4b51e"]])

export default __exports__